import BitmapData = createjs.BitmapData;
export class MouseCursorData {
    private _data: Array<BitmapData>;
    private _frameRate: number;
    private _hotSpot: createjs.Point;

    constructor(){
        this.data = [];
    }


    get data() : Array<BitmapData>{
        return this._data;
    }

    set data(data: Array<BitmapData>){
        this._data = data;
    }

    get frameRate(): number {
        if(this._frameRate === undefined){
            this._frameRate = 0; //default flash value
        }
        return this._frameRate;
    }

    set frameRate(frameRate: number){
        this._frameRate = frameRate;
    }

    get hotSpot(): createjs.Point {
        if(this._hotSpot === undefined){
            this._hotSpot = new createjs.Point(0,0); //default flash value
        }
        return this._hotSpot;
    }

    set hotSpot(hotSpot: createjs.Point) {
        this.hotSpot = hotSpot;
    }

}
